import { financeCatalogGuard } from '@partners/catalog';
import { ContextBuilder } from '../http';

export const provideFinanceCatalogGuard = (): (() => Promise<boolean>) => {
  return async () => {
    const context = new ContextBuilder().addUrlModifiers({ omitProcess: true }).build();
    return await financeCatalogGuard({ context });
  };
};
